import {Diagram, GraphObject, Tool} from 'gojs';

const TOOLTIP_ID_PREFIX = 'canvas-tooltip';

const TOOLTIP_HIDE_DELAY_MS = 500;

const tooltipIds: string[] = [];
let hideTimeout: NodeJS.Timeout;
let currentId = 0;


const cleanUpToolTips = () => {
  while (tooltipIds.length) {
    const id = tooltipIds.shift();
    if (id) {
      const toolTipEl = document.getElementById(id);
      if (toolTipEl) {
        toolTipEl.remove();
      }
    }
  }
};

const createToolTip = (text: string) => {
  tooltipIds.unshift(`${TOOLTIP_ID_PREFIX}-${currentId++}`);
  const el = document.createElement('div');
  el.id = tooltipIds[0];
  el.style.position = 'absolute';
  el.style.willChange = 'transform';
  el.style.top = '0';
  el.style.left = '0';

  el.className = 'tooltip show bs-tooltip-auto';
  el.setAttribute('x-placement', 'bottom');
  // ignoring insecure-document-method as text doesn't come directly from the user and is therefore not at risk.
  // nosemgrep insecure-document-method
  el.innerHTML = `
  <div class="tooltip-inner" role="tooltip">
    <span>${text}</span>
  </div>
  <span class="arrow" style="left: 50%;"></span>
`;

  el.addEventListener('mouseover', () => {
    if (hideTimeout) {
      clearTimeout(hideTimeout);
    }
  });

  el.addEventListener('mouseout', () => {
    hideTimeout = setTimeout(() => {
      cleanUpToolTips();
    }, TOOLTIP_HIDE_DELAY_MS);
  });

  return el;
};

export const makeShowToolTipFn = (text: string) =>
  (_obj: GraphObject, diagram: Diagram, _tool: Tool) => {
    const toolTipDIV = createToolTip(text);
    diagram.div?.appendChild(toolTipDIV);

    const {width} = toolTipDIV.getBoundingClientRect();
    const pt = diagram.lastInput.viewPoint;
    toolTipDIV.style.transform = `translate3d(${pt.x - width / 2}px, ${pt.y}px, 0)`;
  };

export const hideToolTip = (_diagram: Diagram, _tool: Tool) => {
  hideTimeout = setTimeout(() => {
    cleanUpToolTips();
  }, TOOLTIP_HIDE_DELAY_MS);
};
